<template>
  <div v-if="getPermission.ccic.view">

    <md-tabs md-sync-route class="ccic-tab">
      <md-tab id="tab-ccic-application" md-label="IBD" to="/ccic/applications"></md-tab>
      <md-tab id="tab-ccic-container" md-label="Container" to="/ccic/containers"></md-tab>
      
      <!-- <md-tab id="tab-ccic-punchs" md-label="Punchs" to="/ccic/punchs"></md-tab> -->
      <!--<md-tab v-if = "ccicFlag" id="tab-ccic-reminder" md-label="Reminder" to="/ccic/reminder"></md-tab>-->
     
    </md-tabs>
    <router-view/>

  </div>
</template>

<style lang="scss">
  .ccic-tab {
    .md-tabs-navigation {
      .md-theme-default {
        height: 30px;
      }
    }
  }
</style>

<script>
  import { mapGetters } from 'vuex';

  


  export default {
    data: () => ({

      ccicFlag : true,
    }),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>
